import { Injectable } from '@angular/core';
import { IRoomSocketRepository } from 'src/app/core/chat/repository/room/room-socket-repository';
import { GetRoomByIdUseCaseService } from './room-get-by-id-use-case.service'
import { GetRoomListUseCaseService } from 'src/app/core/chat/usecase/room/room-get-list-use-case.service'
@Injectable({
  providedIn: 'root'
})
export class RoomUpdateNameSyncService {

  constructor(
    private GetRoomByIdUseCaseService: GetRoomByIdUseCaseService,
    private roomSocketRepository: IRoomSocketRepository,
    private getRoomListUseCaseService: GetRoomListUseCaseService
  ) {
    this.watch()
  }


  private watch() {
    this.roomSocketRepository.listenToRoomUpdate().subscribe((event) => {
      console.log('listenToRoomUpdate')
      //this.GetRoomByIdUseCaseService.execute(event.data.id)
      this.getRoomListUseCaseService.execute();
    })
  }
}
